/**
 * Jump Box Widget Code
 */
$(document).ready(function(){
	// Custom build jumpbox toggle
	$('.jumpbox-input-select:not(.select_d)').selectBox({
		events: {
			renderItem: function(ul, item){
				var option = $(item.option),
					tagName = 'a',
					wrapperClasses = 'ui-selectbox--item ' + option.attr('class') + (option.is(':selected')?' ui-selectbox-active-item':''),
					entityName = option.text() === '' ? '&nbsp;' : option.text();

				// Greys out and makes inactive agent un selectable.
				return $('<li class="'+wrapperClasses+'" role="menuitem">'+
					'<'+tagName+'>' +
					'<span class="detail">'+
					'<span class="disabled-msg">'+
					'<span>Not active</span>'+
					'</span>'+
					'</span>' +
					entityName +
					'</'+tagName+'>'+
					'</li>')
					.data('item.autocomplete', item)
					.appendTo(ul);
			}
		},
		sourceFilter: 'option'
	});

	$('#jumpboxwidget:not(.show-jumpbox)').bind('mouseover', function(){
		$(this).find('.slider').animate({
			marginLeft: 0
		}, 'fast', function(){
			$('#jumpboxwidget').addClass('show-jumpbox');
		});
	});
	$('.jumpbox-input-select').bind('change', function(){
		var val = $(this).find('option:selected').val();
		$.fullPageLoading(true, 'Loading...');
		window.location.href = $(this).data('url').replace(':VALUE:', val);
	});
});